import { DEFAULTS_FIELD_VALUES } from './constants';

const getFormattedOptions = ({ data, error, isLoading, skip }) => {
  if (skip) {
    return {
      isLoading: isLoading && !data?.allActiveOptionValues,
      error,
      allOptionsValues: null,
      allOptionsByValuesKey: null,
    };
  }

  const allActiveOptionValues = data?.allActiveOptionValues ?? [];

  const allOptionsValues = allActiveOptionValues?.reduce((acc, optionValue) => {
    if (!optionValue) {
      return acc;
    }

    const optionValueWithDefaults = {
      ...DEFAULTS_FIELD_VALUES,
      ...optionValue,
    };

    return {
      ...acc,
      [optionValue.id]: optionValueWithDefaults,
    };
  }, {});

  const allOptionsByValuesKey = Object.values(allOptionsValues).reduce(
    (acc, optionValue) => {
      if (!optionValue?.value) {
        return acc;
      }

      const optionValueKey = optionValue.value
        .toLowerCase()
        .trim()
        .split(' ')
        .join('-');

      return {
        ...acc,
        [optionValueKey]: optionValue,
      };
    },
    {}
  );

  return {
    isLoading: isLoading && !data?.allActiveOptionValues,
    error,
    allOptionsValues,
    allOptionsByValuesKey,
  };
};

export default getFormattedOptions;
